import { DateType } from '@tiendanube/common';
import { PromotionType } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { PROMOTIONS_ROUTES } from './promotionsRoutes';
import {
  buildUrl,
  DATE_TYPE_QUERY_PARAM,
  DISCOUNT_OPTION_ID_QUERY_PARAM,
} from '../marketingRoutes';

export const PROMOTION_TYPE_QUERY_PARAM = 'promotion_type';

interface PromotionUrlParams {
  promotionType?: PromotionType;
  dateType?: DateType;
  discountOptionId?: string;
}

export const buildNewPromotionUrl = ({
  promotionType,
  dateType,
  discountOptionId,
}: PromotionUrlParams): string =>
  buildUrl(PROMOTIONS_ROUTES.newPromotions, {
    [PROMOTION_TYPE_QUERY_PARAM]: promotionType,
    [DATE_TYPE_QUERY_PARAM]: dateType,
    [DISCOUNT_OPTION_ID_QUERY_PARAM]: discountOptionId,
  });
